module.exports = __webpack_public_path__ + "img/focus.922b81c0.png";